define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/encode',
    '../Util/callbackSystem',
    '../System/Vec3Obj'
], function (
    defaultValue,
    defined,
    encode,
    callbackSystem,
    Vec3Obj
) {
    'use strict'

    /**
     * 视域分析。
     * <br /><br />
     * <div align='center'>
     * <img src='images/ViewShedAnalysis.png' width='900' height='650' /><br />
     * 视域分析效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/ViewShedAnalysis.html|CooWasm ViewShedAnalysis demo}
     * @alias ViewShedAnalysis
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {Vec3Obj} [props.translation=new Vec3Obj(0.0, 0.0, 0.0)] x、y、z轴偏移值。
     * @param {Vec3Obj} [props.scale=new Vec3Obj(1.0, 1.0, 1.0)] x、y、z轴比例值。
     * @param {Vec3Obj} [props.rotation=new Vec3Obj(0.0, 0.0, 0.0)] x、y、z轴旋转值。
     * @param {Vec3Obj} [props.eyePoint=null] 观察点坐标值。
     * @param {Vec3Obj} [props.aimPoint=null] 目标点坐标值。
     * @param {Number} [props.hAngle=60.0] 视域水平张角，单位：角度。
     * @param {Number} [props.vAngle=40.0] 视域垂直张角，单位：角度。
     * @param {Number} [props.visibilityDistance=3000.0] 视域分析可视距离。
     * @param {Boolean} [props.bVisible=true] 显隐状态。
     * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
     * @example
     * var analysis = new CooWasm.ViewShedAnalysis({},(state)=>{console.log("load status:" + state)})
     */
    class ViewShedAnalysis {
        /**
         * @description 视域分析x、y、z轴偏移值。
         * @type {Vec3Obj}
         * @readonly
         */
        translation
        /**
         * @description 视域分析x、y、z轴比例值。
         * @type {Vec3Obj}
         * @readonly
         */
        scale
        /**
         * @description 视域分析x、y、z轴旋转值。
         * @type {Vec3Obj}
         * @readonly
         */
        rotation
        // /**
        //  * @description 视域分析地理位置坐标值，默认为当前视点目标点位置。
        //  * @type {Vec3Obj}
        //  */
        // location
        /**
         * @description 视域分析观察点位置坐标。
         * @type {Vec3Obj}
         */
        eyePoint
        /**
         * @description 视域分析目标点位置坐标。
         * @type {Vec3Obj}
         */
        aimPoint
        /**
         * @description 视域分析水平张角，单位：角度。
         * @type {Number}
         */
        hAngle
        /**
         * @description 视域分析垂直张角，单位：角度。
         * @type {Number}
         */
        vAngle
        /**
         * @description 视域分析可视距离。
         * @type {Number}
         */
        visibilityDistance
        /**
         * @description 视域分析显隐状态。
         * @type {Boolean}
         * @default true
         */
        bVisible = true

        /**
         * @description 视域分析对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null
        /**
         * @description 视域分析组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null
        /**
         * @description ViewShedAnalysis在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "ViewShedAnalysis"
        static avatarType = "deSpace.SpaceAvatar.ViewShedAnalysis"
        static componentType = null

        constructor(props, callback) {
            if (!defined(props)) {
                props = {}
            }
            if(defined(props.build) && props.build == true){
                return
            }
            this.translation = defaultValue(props.translation, new Vec3Obj(0.0, 0.0, 0.0))
            this.scale = defaultValue(props.scale, new Vec3Obj(1.0, 1.0, 1.0))
            this.rotation = defaultValue(props.rotation, new Vec3Obj(0.0, 0.0, 0.0))
            //this.location = defaultValue(props.location, null)
            this.eyePoint = defaultValue(props.eyePoint, null)
            this.aimPoint = defaultValue(props.aimPoint, null)
            this.hAngle = defaultValue(props.hAngle, 60.0)
            this.vAngle = defaultValue(props.vAngle, 40.0)
            this.visibilityDistance = defaultValue(props.visibilityDistance, 3000.0)
            this.bVisible = defaultValue(props.bVisible, true)
            //create avatars
            var aCategory = encode("deSpace.SpaceAvatar")
            var aName = encode("ViewShedAnalysis")
            var cCategory = encode("")
            var cName = encode("")
            var aProps = ""
            var cProps = ""
            aProps += this.toStr("bVisible", props.bVisible, "Visible")
            aProps += this.toStr("eyePoint", props.eyePoint, "ObservationPoint")
            aProps += this.toStr("aimPoint", props.aimPoint, "AimPoint")
            aProps += this.toStr("hAngle", props.hAngle, "HAngle")
            aProps += this.toStr("vAngle", props.vAngle, "VAngle")
            aProps += this.toStr("visibilityDistance", props.visibilityDistance, "VisibilityDistance")
            
            var idInfo = Element.prototype.NativeAPI.LoadAvatarAndComponent(encode(""), aCategory, aName, encode(aProps), cCategory, cName, encode(cProps), encode(""), encode(""), this.bVisible, true)
            if (idInfo != "") {
                var idArray = idInfo.split('#$%')
                this.avatarUuid = idArray[0]
                this.componentUuid = idArray[1]
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                    Element.prototype.Map.viewShedAnalysiss.push(this)
                })
                //console.log("ViewShedAnalysis avatarUuid:" + this.avatarUuid + " componentUuid:" + this.componentUuid)
            }
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {Vec3Obj} [props.translation] x、y、z轴偏移值。
         * @param {Vec3Obj} [props.scale] x、y、z轴比例值。
         * @param {Vec3Obj} [props.rotation] x、y、z轴旋转值。
         * @param {Vec3Obj} [props.eyePoint] 观察点坐标值。
         * @param {Vec3Obj} [props.aimPoint] 目标点坐标值。
         * @param {Number} [props.hAngle] 视域水平张角，单位：角度。
         * @param {Number} [props.vAngle] 视域垂直张角，单位：角度。
         * @param {Number} [props.visibilityDistance] 视域分析可视距离。
         * @param {Boolean} [props.bVisible] 显隐状态。
         * @param {CallbackBoolean} [callback=null] 更新成功后触发的函数回调。
         * @example
         * analysis.update({
         *    bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, callback) {
            let avatarProps = ""
            let componentProps = ""
            if (defined(props)) {
                avatarProps += this.toStr("translation", props.translation, "Translation")
                avatarProps += this.toStr("scale", props.scale, "Scale")
                avatarProps += this.toStr("rotation", props.rotation, "Rotation")
                avatarProps += this.toStr("eyePoint", props.eyePoint, "ObservationPoint")
                avatarProps += this.toStr("aimPoint", props.aimPoint, "AimPoint")
                avatarProps += this.toStr("hAngle", props.hAngle, "HAngle")
                avatarProps += this.toStr("vAngle", props.vAngle, "VAngle") 
                avatarProps += this.toStr("visibilityDistance", props.visibilityDistance, "VisibilityDistance")
                avatarProps += this.toStr("bVisible", props.bVisible, "Visible")
                
                callbackSystem.register("UpdateAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                })
                Element.prototype.NativeAPI.UpdateAvatarAndComponent(encode(this.avatarUuid), encode(this.componentUuid), encode(avatarProps), encode(componentProps), defined(callback))
            }
        }
        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        /**
         * 从场景中定位自身(自动根据数据包围盒定位，不可修改定位参数)。
         * @param {CallbackBoolean} [callback=null] 飞行结束后触发的函数回调。
         * @example
         * analysis.locate((state)=>{console.log("locate status:" + state)})
         */
        locate(callback) {
            callbackSystem.register("", "LocateAvatar", (state) => {
                if (defined(callback)) {
                    callback(state)
                }
            })
            Element.prototype.NativeAPI.LocateAvatar(encode(this.avatarUuid))
        }

        /**
         * 获取视域分析包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * analysis.getProperties()
         */
        getProperties() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!")
                return false
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New()
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid))
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true
                    } else {
                        this.bVisible = false
                    }
                } else if (name == "Scale") {
                    this.scale = Vec3Obj.fromStr(value)
                } else if (name == "Rotation") {
                    this.rotation = Vec3Obj.fromStr(value)
                } else if (name == "Translation") {
                    this.translation = Vec3Obj.fromStr(value)
                } else if (name == "ObservationPoint") {
                    this.eyePoint = Vec3Obj.fromStr(value)
                } else if (name == "AimPoint") {
                    this.aimPoint = Vec3Obj.fromStr(value)
                } else if (name == "HAngle") {
                    this.hAngle = Number(value)
                } else if (name == "VAngle") {
                    this.vAngle = Number(value)
                } else if (name == "VisibilityDistance") {
                    this.visibilityDistance = Number(value)
                }
            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar)
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid)
            return true
        }
        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁后触发的函数回调。
         * @returns null 空值。
         * @example
         * analysis = analysis.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy(callback) {
            if (!defined(this.avatarUuid)) {
                console.log("avatarUuid is null!")
                return null
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state)
                }
                Element.prototype.Map.viewShedAnalysiss = Element.prototype.Map.viewShedAnalysiss.filter(item => item !== this)
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("UpdateAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("", "LocateAvatar")
                callbackSystem.remove("RemoveAvatar", this.avatarUuid)
                this.avatarUuid = null
                this.componentUuid = null
            })
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid))
            return null
        }
    }
    return ViewShedAnalysis
})